module.exports = __webpack_public_path__ + "static/img/pelvis1_1.dc2e8ac8.png";